// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_617f760","won":"_9c8799b","extraWallet":"_d8c3a80","stakeInfo":"_6306d09","returnInfo":"_4d9bf2f"};